.container {
  height: 100%;
  width: 100%;
  padding: 0.5rem;
}

/* Body-mounted host for Monaco's overflowing widgets (see
 * `useOverflowWidgetsHost`). It holds no layout of its own — the widgets
 * inside it are `position: fixed` — so it collapses to a zero-size box out of
 * the document flow. The z-index has to clear the popovers the editor is
 * embedded in, which sit at 1300 alongside MUI's modal layer. */
.overflow-widgets {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1400;
}
